import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CategoryView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerCatalog } from "@/lib/query/core/invalidation";

type CreateCategoryInput = {
  storeSlug: string;
  nameAr: string;
  nameEn: string | null;
  sortOrder?: number;
};

export function useCreateCategoryMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: CreateCategoryInput) => {
      const { storeSlug, ...body } = input;
      void storeSlug;
      return apiJsonClient<CategoryView>(endpoints.seller.categories, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
    },
    onSuccess: async (_data, variables) => {
      await invalidateSellerCatalog(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
